
export function checkImgType (file) {
  if (!/\.(jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name)) {
    return false
  } else {
    return true
  }
}
